import { axios } from '@/services/axios';

const updateNumber = async ({ updatedNumber, currentScope }) => {
    const res = await axios.put('/Number', updatedNumber, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default updateNumber;
